module.exports = __webpack_public_path__ + "img/fundermax-new-logo-white.ea7516c0.png";